import type { ComponentProps } from 'react';

/** A diamond always means one editable key; counts identify collapsed groups. */
export function TimelineKeyMarker({ count = 1, className = '', ...props }: Omit<ComponentProps<'button'>, 'children'> & { count?: number }) {
  return <button {...props} type="button" draggable={false} className={`timeline-attribute-key ${className}${count > 1 ? ' timeline-key-cluster' : ''}`}
    data-keyframe-marker={count > 1 ? 'cluster' : 'key'}>{count > 1 ? `${count} keys` : <span className="timeline-key-glyph" aria-hidden="true">◆</span>}</button>;
}
